import { FC } from 'react';
import styles from './styles.module.scss';
import { DocumentRichIcon } from '@/common/icons/DocumentRichIcon';
import DownloadIcon from '@/common/svg/download-icon.svg';
import { DocumentProps } from '@/common/types/documents';

interface Props {
  documents: DocumentProps[];
}

const DocumentsList: FC<Props> = ({ documents }) => {
  return (
    <div className={styles.wrapper}>
      {documents.map(({ name, url }) => (
        <a
          key={url}
          className={styles.row}
          href={url}
          target="_blank"
          rel="noreferrer"
        >
          <div className={styles.rightSide}>
            <DocumentRichIcon />
            <span className="font-bold">{name}</span>
          </div>
          <div className={styles.leftSide}>
            <DownloadIcon />
          </div>
        </a>
      ))}
    </div>
  );
};

export default DocumentsList;
